module.exports = __webpack_public_path__ + "img/api-integration.6f3b0d7d.webp";